import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const resourceDocumentsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getResourceDocuments: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getResourceDocuments,
        method: 'get',
      }),
      providesTags: ['ResourceDocuments'],
    }),
    addResourceDocument: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addResourceDocument,
        method: 'post',
        data: data.body,
      }),
      invalidatesTags: (result) => (result ? ["ResourceDocuments"] : []),
    }),
    updateResourceDocument: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateResourceDocument}/${data.id}?_method=put`,
        method: 'post',
        data: data.body,
      }),
      invalidatesTags: (result) => (result ? ["ResourceDocuments"] : []),
    }),
    deleteResourceDocument: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteResourceDocument}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['ResourceDocuments'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetResourceDocumentsQuery,
  useAddResourceDocumentMutation,
  useUpdateResourceDocumentMutation,
  useDeleteResourceDocumentMutation
} = resourceDocumentsApi;

